<template>
  <div v-if="isready">
    <van-tabs type="line" v-model="active" @change="tabcg">
      <van-tab title="积分榜">
        <van-empty v-if="list.length == 0" description="暂无排行" />
        <div v-if="list.length > 0">
          <div class="hero">
            <div class="pad" v-if="list[1]">
              <div class="first">
                <img class="headimg" :src="list[1].avatar" alt="" />
              </div>
              <div class="namebtn">{{ list[1].name }}</div>
              <div class="num">{{ list[1].numbers }}积分</div>
            </div>
            <div class="pad" v-if="list[0]">
              <div class="second">
                <img class="headimg" :src="list[0].avatar" alt="" />
              </div>
              <div class="namebtn">{{ list[0].name }}</div>
              <div class="num">{{ list[0].numbers }}积分</div>
            </div>
            <div class="pad" v-if="list[2]">
              <div class="third">
                <img class="headimg" :src="list[2].avatar" />
              </div>
              <div class="namebtn">{{ list[2].name }}</div>
              <div class="num">{{ list[2].numbers }}积分</div>
            </div>
          </div>

          <div class="otherbox">
            <div class="item" v-for="(v, i) in list" :key="i" v-if="i > 2">
              <div class="idx">{{ i + 1 }}</div>
              <img class="avater" style="" :src="v.avatar" alt="" />
              <div class="name">{{ v.name }}</div>
              <div class="jf">{{ v.numbers }}积分</div>
            </div>
          </div>
        </div>
      </van-tab>
      <van-tab title="挑战榜">
        <van-empty v-if="list.length == 0" description="暂无排行" />
        <div v-if="list.length > 0">
          <div class="hero">
            <div class="pad" v-if="list[1]">
              <div class="first">
                <img class="headimg" :src="list[1].avatar" alt="" />
              </div>
              <div class="namebtn">{{ list[1].name }}</div>
              <div class="num">{{ list[1].numbers }}积分</div>
              <div class="num">{{ list[1].miaos }}</div>
            </div>
            <div class="pad" v-if="list[0]">
              <div class="second">
                <img class="headimg" :src="list[0].avatar" alt="" />
              </div>
              <div class="namebtn">{{ list[0].name }}</div>
              <div class="num">{{ list[0].numbers }}积分</div>
              <div class="num">{{ list[0].miaos }}</div>
            </div>
            <div class="pad" v-if="list[2]">
              <div class="third">
                <img class="headimg" :src="list[2].avatar" />
              </div>
              <div class="namebtn">{{ list[2].name }}</div>
              <div class="num">{{ list[2].numbers }}积分</div>
              <div class="num">{{ list[2].miaos }}</div>
            </div>
          </div>

          <div class="otherbox">
            <div class="item" v-for="(v, i) in list" :key="i" v-if="i > 2">
              <div class="idx">{{ i + 1 }}</div>
              <img class="avater" style="" :src="v.avatar" alt="" />
              <div class="name">
                <div>{{ v.name }}</div>
                <div>{{ v.miaos }}</div>
              </div>
              <div class="jf">{{ v.numbers }}积分</div>
            </div>
          </div>
        </div>
      </van-tab>
    </van-tabs>
  </div>
</template>

<script>
import Vue from "vue";
import { Tab, Tabs, Empty } from "vant";
import { Challenge, Scoreboard } from "@/api/answer";

Vue.use(Empty);
Vue.use(Tab);
Vue.use(Tabs);
export default {
  data() {
    return {
      active: 0,
      list: [],
      isready: false,
    };
  },
  mounted() {
    this.getdata();
  },
  methods: {
    getdata() {
      if (this.active == 0) {
        Scoreboard().then((res) => {
          console.log(111);
          console.log(res);
          this.list = res.data.list;
          this.isready = true;
        });
      } else {
        Challenge().then((res) => {
          console.log(222);
          console.log(res);
          this.isready = true;
          this.list = res.data.list;
        });
      }
    },
    tabcg() {
      this.list =[];
      this.getdata();
    },
  },
};
</script>

<style scoped>
.hero {
  height: 5rem;
  width: 100%;
  background-image: url("~@/assets/img/herobg.jpg");
  background-size: 100% 100%;
  padding: 0.26rem 0.35rem;
  padding-top: 0.8rem;
  display: flex;
  justify-content: space-around;
}
.first {
  height: 2rem;
  width: 1.8rem;
  background: url("~@/assets/img/second.png") no-repeat;
  background-size: 100% 100%;
  margin-top: 0.5rem;
}
.second {
  height: 2.5rem;
  width: 2.25rem;
  background: url("~@/assets/img/first.png") no-repeat;
  background-size: 100% 100%;
}
.third {
  height: 2rem;
  width: 1.8rem;
  background: url("~@/assets/img/third.png") no-repeat;
  background-size: 100% 100%;
  margin-top: 0.5rem;
}
.headimg {
  width: 97%;
  height: 83%;
  margin-top: 17%;
  border-radius: 50%;
  margin-left: 1%;
}
.namebtn {
  font-size: 0.25rem;
  line-height: 0.5rem;
  text-align: center;
  margin: 0 auto;
  margin-top: 0.2rem;
  background: #fcebeb;
  color: #d81e07;
  border-radius: 0.1rem;
}
.num {
  margin-top: 0.1rem;
  color: #ffff;
  text-align: center;
}
.otherbox {
  padding: 0.2rem;
}
.otherbox .item {
  display: flex;
  align-items: center;
  margin-bottom: 0.3rem;
}
.avater {
  height: 1rem;
  width: 1rem;
  border-radius: 50%;
  margin-left: 0.2rem;
}
.idx {
  font-size: 0.4rem;
  margin-left: 0.3rem;
}
.jf {
  color: rgb(216, 30, 7);
  margin-left: auto;
  margin-right: 0.3rem;
}
.name {
  font-size: 0.3rem;
  margin-left: 0.2rem;
}
.pad{
    padding: 0 0.2rem;
}
</style>